import { useEffect, useState } from 'react';

import type { CheckoutFragment } from '@/graphql/saleor/api';

export const getShoppingBagExpressCheckoutKey = (
  checkout: Partial<CheckoutFragment> | null | undefined,
  countryCode: string,
  locale: string,
) => {
  if (!checkout?.id || !checkout.lines?.length) return null;

  return JSON.stringify([
    checkout.id,
    checkout.channel?.slug,
    checkout.totalPrice?.gross.currency,
    countryCode,
    locale,
  ]);
};

export const useShoppingBagExpressMount = (
  checkoutKey: string | null,
  isReadyToMount: boolean,
) => {
  const [mountedCheckout, setMountedCheckout] = useState<{
    checkoutKey: string | null;
    isMounted: boolean;
  }>({
    checkoutKey: null,
    isMounted: false,
  });

  useEffect(() => {
    setMountedCheckout((current) => {
      if (current.checkoutKey !== checkoutKey) {
        return {
          checkoutKey,
          isMounted: checkoutKey !== null && isReadyToMount,
        };
      }

      if (isReadyToMount && !current.isMounted) {
        return { checkoutKey, isMounted: true };
      }

      return current;
    });
  }, [checkoutKey, isReadyToMount]);

  return (
    checkoutKey !== null &&
    mountedCheckout.checkoutKey === checkoutKey &&
    mountedCheckout.isMounted
  );
};
